import { render } from "./TechnologyComponent.vue?vue&type=template&id=5ad39d51&scoped=true"
import script from "./TechnologyComponent.vue?vue&type=script&lang=js"
export * from "./TechnologyComponent.vue?vue&type=script&lang=js"

import "./TechnologyComponent.vue?vue&type=style&index=0&id=5ad39d51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad39d51"]])

export default __exports__